import type { UseQueryResult } from "@tanstack/react-query";
import { useQuery } from "@tanstack/react-query";

import type { ReserveSnapshot } from "./reserveHistory";
import { fetchReportingHistory } from "./useJachinReporting";

export async function fetchReserveHistory(from: string, to: string, signal?: AbortSignal): Promise<ReserveSnapshot[]> {
    const rows = await fetchReportingHistory("token-backing-history", from, to, signal);
    return rows.map((row) => ({
        at: row.at,
        custody: null,
        yieldDistributors: null,
        reserveFund: null,
        vault:
            row.totalUsd === null
                ? null
                : row.holdings
                      .filter((h) => h.amountUsd !== null)
                      .map((h) => ({ asset: h.symbol, amount: h.amount, amountUsd: h.amountUsd! }))
    }));
}

export function useReportingReserveHistory(): UseQueryResult<ReserveSnapshot[], Error> {
    const today = new Date().toISOString().slice(0, 10);
    const midnight = Date.parse(`${today}T00:00:00Z`);
    const from = new Date(midnight - 90 * 86400000).toISOString().slice(0, 10);
    const to = new Date(midnight + 86400000).toISOString().slice(0, 10);
    return useQuery({
        queryKey: ["reporting-reserve-history", from, to],
        queryFn: ({ signal }) => fetchReserveHistory(from, to, signal),
        staleTime: 5 * 60 * 1000,
        refetchInterval: 5 * 60 * 1000,
        retry: 2
    });
}
